import { Backdrop, CircularProgress, Stack, Typography } from '@mui/material';

const IFOOD_RED = '#EA1D2C';

const IfoodLoadingBackdrop = ({ open, message = 'Aguardando resposta do iFood…' }) => (
  <Backdrop
    open={Boolean(open)}
    sx={(theme) => ({
      zIndex: theme.zIndex.modal + 10,
      backgroundColor: 'rgba(15, 23, 42, 0.58)',
      backdropFilter: 'blur(2px)',
    })}
  >
    <Stack
      role="status"
      aria-live="polite"
      alignItems="center"
      spacing={1.5}
      sx={{
        width: 'min(90vw, 380px)',
        borderRadius: '18px',
        backgroundColor: '#ffffff',
        color: '#0f172a',
        px: 3,
        py: 2.5,
        boxShadow: '0 24px 64px rgba(15, 23, 42, 0.28)',
        textAlign: 'center',
      }}
    >
      <CircularProgress size={34} sx={{ color: IFOOD_RED }} />
      <Typography variant="subtitle2" fontWeight={800}>
        {message}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Aguarde a confirmação antes de continuar.
      </Typography>
    </Stack>
  </Backdrop>
);

export default IfoodLoadingBackdrop;
